import { render, staticRenderFns } from "./CreateInvoice.vue?vue&type=template&id=640435f9&scoped=true"
import script from "./CreateInvoice.vue?vue&type=script&lang=js"
export * from "./CreateInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640435f9",
  null
  
)

export default component.exports